import { render, staticRenderFns } from "./NotificationPage.vue?vue&type=template&id=4595e468"
import script from "./NotificationPage.vue?vue&type=script&lang=js"
export * from "./NotificationPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationPage.vue?vue&type=style&index=0&id=4595e468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports